import { state } from './state';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

const searchExams = {
  state,
  mutations,
  getters,
  actions,
};

export default searchExams;
